import { HelpModal } from 'components/ui/help-modal';
import { COIN_ART } from 'pages/Reconhecer/components/recognition-art';
import { CoinKey } from 'pages/Reconhecer/recognition-points';
import { GetMoedaDescription } from 'utils/strings';

// As mesmas ilustrações da etapa "Tipo e pontos" do Reconhecer.
const COINS: { key: CoinKey; label: string }[] = [
  { key: 'uau', label: '#UAU = 300 pontos' },
  { key: 'mandou', label: '#MANDOU BEM = 200 pontos' },
  { key: 'valeu', label: '#VALEU = 100 pontos' },
];

export function SeloMoedasModal() {
  return (
    <HelpModal modalId="help-moedas-bb" title="Saiba mais sobre os pontos para reconhecimento" size="md">
      <ul className="m-0 list-none divide-y divide-surface-200 p-0">
        {COINS.map(({ key, label }) => (
          <li key={key} className="py-3 first:pt-0 last:pb-0">
            <div className="flex items-center gap-3">
              <img src={COIN_ART[key]} alt="" className="h-10 w-10 shrink-0 object-contain" />
              {/* Declara o próprio `leading-*` contra o reset global do rsuite. */}
              <h3 className="m-0 font-display text-base font-bold leading-tight text-brand-blue-dark">{label}</h3>
            </div>
            <p className="m-0 mt-1.5">{GetMoedaDescription(key)}</p>
          </li>
        ))}
      </ul>
    </HelpModal>
  );
}
